module.exports = __webpack_public_path__ + "img/all_data.422121ac.svg";